import React from 'react';
import { Switch, Route, Redirect, RouteComponentProps } from 'react-router-dom';
import EditProductCategoriesContext from 'contexts/EditProductCategoriesContext';
import AppContext from 'contexts/AppContext';
import ProductCategory from 'types/models/ProductCategory';
import ListProductCategoriesPage from 'pages/private/admin/ListProductCategoriesPage';
import CreateProductCategoriesPage from 'pages/private/admin/CreateProductCategoriesPage';
import EditProductCategoriesPage from 'pages/private/admin/EditProductCategoriesPage';
import { hasPermission } from 'utils/hasPermission';
import PermissionCode from 'types/enums/PermissionCode';

export default ({ match }: RouteComponentProps): JSX.Element => {
  const { permissions } = React.useContext(AppContext);
  const [selectedProductCategory, setSelectedProductCategory] = React.useState<ProductCategory | null>(null);

  if (!hasPermission(permissions, PermissionCode.ProductCategoriesView)) {
    return <Redirect to="/private/welcome" />;
  }

  return (
    <EditProductCategoriesContext.Provider value={{ selectedProductCategory, setSelectedProductCategory }}>
      <Switch>
        <Route exact={true} path={`${match.url}`} component={ListProductCategoriesPage} />
        <Route path={`${match.url}/create`} component={CreateProductCategoriesPage} />
        <Route path={`${match.url}/edit`} component={EditProductCategoriesPage} />
        <Redirect to="/private/welcome" />
      </Switch>
    </EditProductCategoriesContext.Provider>
  );
};
